/**
 * @typedef {Object} ContentMetadata
 * @property {string} hash
 * @property {string} id
 * @property {string} type
 * @property {string} source
 * @property {string} editUrl
 */

class ContentMetadataStore {
  /**
   * @param {ContentMetadata[]} initialData
   */
  constructor(initialData) {
    this.data = initialData;
  }

  /**
   * @param {ContentMetadata} contentMetadata
   */
  add(contentMetadata) {
    if (this.hasExistingMetadata(contentMetadata)) {
      return;
    }
    this.data = [...this.data, contentMetadata];
  }

  /**
   * @param {string} type
   * @param {string} id
   * @return {ContentMetadata[]}
   */
  find(type, id) {
    return this.data.filter((metadata) => {
      return metadata.type === type && metadata.id === id;
    });
  }

  /**
   * @param {ContentMetadata} contentMetadata
   * @return {boolean}
   * @private
   */
  hasExistingMetadata(contentMetadata) {
    return this.data.some((metadata) => {
      return metadata.hash === contentMetadata.hash;
    });
  }
}

export default ContentMetadataStore;
